import styled from "@emotion/styled";
import { baseTheme } from "@avenue-8/sidekick-ui";
import { useGetPromptLibrary } from "@queries/chat/useGetPromptLibrary";
import type { PromptLibraryItem } from "@shared/apis/sidekick/generated";
import { ExplorePromptsPanel } from "./ExplorePrompts/ExplorePromptsPanel";

const ExploreSkeleton = styled.div`
  grid-area: suggestions;
  background: ${baseTheme.colors.blue5};
`;

type Props = {
  isSendingMessage: boolean;
  onSelectItem: (item: PromptLibraryItem) => void;
  onBack: () => void;
};

export const ChatExploreView = ({
  isSendingMessage,
  onSelectItem,
  onBack,
}: Props) => {
  const { data, isLoading, isError, refetch } = useGetPromptLibrary();
  return (
    <ExplorePromptsPanel
      categories={data?.categories ?? []}
      isLoading={isLoading}
      isError={isError}
      disabled={isSendingMessage}
      onRetry={() => void refetch()}
      onSelectItem={onSelectItem}
      onBackToNewChat={onBack}
    />
  );
};

export const ChatExploreViewSkeleton = () => <ExploreSkeleton />;
